import ListReportDiaRuta from "./list"
import ShowDiaRuta from "./show"

export default {
	show: ShowDiaRuta,
	list : ListReportDiaRuta,
}
